var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui-page-header",
      attrs: { title: "History", subtitle: "Crash game history" },
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "return-btn-con" }, [
        _c(
          "button",
          {
            staticClass: "return-btn",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [
            _c("c-svg", {
              attrs: {
                src: "return.svg",
                width: "21px",
                height: "21px",
                fill: "rgb(217, 222, 229)",
              },
            }),
            _c("div", { staticClass: "text" }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "page-header__title" }, [
        _c("i", { staticClass: "icon icon_history" }),
        _vm._v(" History "),
      ]),
      _c("div", { staticClass: "page-header__subtitle" }, [
        _vm._v(" Crash game history "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }